<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/gardenList' }">
					<i class="el-icon-school"></i> 幼儿园管理
				</el-breadcrumb-item>
				<el-breadcrumb-item>添加幼儿园</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="155px">

				<el-row>
					<el-col :span="22">
						<el-form-item :label="'校徽'" prop="saaLOGO">
							<!-- <el-upload class="avatar-uploader" action="" :show-file-list="false" :auto-upload="false" :on-change="uploadImg">
					   	<el-image v-if="ruleForm.saaLOGO" fit="fill" disabled :src="ruleForm.saaLOGO" class="avatar"></el-image>
					   	<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					   </el-upload> -->
							<el-upload action="" :show-file-list="false" :auto-upload="false" :on-change="uploadImg" list-type="picture-card">
								<el-image v-if="ruleForm.saaLOGO" fit="fill" disabled :src="ruleForm.saaLOGO"></el-image>
								<i v-else class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="12">
						<el-form-item :label="'幼儿园名称'" prop="saaNAME">
							<el-input v-model="ruleForm.saaNAME" :placeholder="'请输入幼儿园名称'" maxlength="50"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="14">
						<el-form-item :label="'类型'" prop="saaSTAT">
							<el-radio-group v-model="ruleForm.saaSTAT">
								<el-radio label="1">全日制</el-radio>
								<el-radio label="2">寄宿制</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="22">
						<el-form-item :label="'所在省'" prop="saaPAAI">
							<el-select v-model="ruleForm.saaPAAI" clearable :placeholder="'请选择省'" class="handle-select mr10" @change="paaiChange(ruleForm.saaPAAI)">
								<el-option v-for="item in ruleForm.optionsPAAI" :key="item.PAAMSID" :label="item.PAANAME" :value="item.PAAMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="22">
						<el-form-item :label="'所在市'" prop="saaPABI">
							<el-select v-model="ruleForm.saaPABI" clearable :placeholder="'请选择市'" class="handle-select mr10" :disabled="disabledPABI"
							 @change="getPACI(ruleForm.saaPAAI,ruleForm.saaPABI)">
								<el-option v-for="item in ruleForm.optionsPABI" :key="item.PABMSID" :label="item.PABCITY" :value="item.PABMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="22">
						<el-form-item :label="'所在区'" prop="saaPACI">
							<el-select v-model="ruleForm.saaPACI" clearable :placeholder="'请选择区'" class="handle-select mr10" :disabled="disabledPACI">
								<el-option v-for="item in ruleForm.optionsPACI" :key="item.PACMSID" :label="item.PACDQNM" :value="item.PACMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="22">
						<el-form-item :label="'详细地址'" prop="saaADRS">
							<el-input v-model="ruleForm.saaADRS" :placeholder="'请输入详细地址'" maxlength="200"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="22">
						<el-form-item :label="'电话'" prop="saaPTEL">
							<el-input v-model="ruleForm.saaPTEL" :placeholder="'请输入电话'" maxlength="20"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="22">
						<el-form-item :label="'园长姓名'" prop="saaUAAI">
							<el-select v-model="ruleForm.saaUAAI" clearable :placeholder="'请选择园长'" class="handle-select mr10" :disabled="disabledUAAI">
								<el-option v-for="item in ruleForm.optionsUAAI" :key="item.UAAMSID" :label="item.UAANAME" :value="item.UAAMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="22">
						<el-form-item :label="'院校简介'" prop="saaNOTE">
							<el-input v-model="ruleForm.saaNOTE" :placeholder="'请输入院校简介'" maxlength="1000"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'校园展示'" prop="saaSMG1">
							<el-upload action="" :show-file-list="false" :auto-upload="false" :on-change="uploadImgSMG1" list-type="picture-card">
								<el-image v-if="ruleForm.saaSMG1" fit="fill" disabled :src="ruleForm.saaSMG1"></el-image>
								<i v-else class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
					</el-col>
					<el-col :span="12"></el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'校园风采'" prop="editFiles_CD">
							<el-upload ref="imgdaa" action="" multiple :limit="3" :file-list="this.ruleForm.editFiles_CD" :auto-upload="false"
							 list-type="picture-card" :on-change="uploadMABImg_HJ" :on-exceed="handleExceed_HJ" :on-remove="handleRemove_HJ">
								<i class="el-icon-plus"></i>
							</el-upload>
							<span style=" width:150%; height: 10px; padding-top: 10px; font-size: 14px;color: #999999;">
								最多可以上传3张图片，JPG、PNG、JPEG 格式图片。
							</span>
						</el-form-item>

					</el-col>
				</el-row>
				<!-- <el-row>
					<el-col :span="22">
						<el-form-item :label="'预存款'" prop="saaYCJE">
							<el-input v-model="ruleForm.saaYCJE" :placeholder="'请输入预存款'" maxlength="5"></el-input>
						</el-form-item>
					</el-col>
				</el-row> -->
				<el-row>
					<el-col :span="22">
						<el-form-item :label="'招生计划'" prop="saaZSJH">
							<el-input v-model="ruleForm.saaZSJH" :placeholder="'请输入招生计划'" maxlength="500"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="22">
						<el-form-item :label="'报名时间'" prop="saaBMSJ">
							<el-input v-model="ruleForm.saaBMSJ" :placeholder="'请输入报名时间'" maxlength="200"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="22">
						<el-form-item :label="'老师上班时间'" prop="saaWINT">
							<!-- <el-input v-model="ruleForm.saaWINT" :placeholder="'请输入老师上班时间'" maxlength="200"></el-input> -->
							<el-time-select style="width: 200px;"
							  v-model="ruleForm.saaWINT"
							  :picker-options="{
							    start: '05:30',
							    step: '00:10',
							    end: '09:00'
							  }"
							  placeholder="请选择老师上班时间">
							</el-time-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="22">
						<el-form-item :label="'老师下班时间'" prop="saaWOUT">
							<!-- <el-input v-model="ruleForm.saaWOUT" :placeholder="'请输入老师下班时间'" maxlength="200"></el-input> -->
							<el-time-select  style="width: 200px;"
							  v-model="ruleForm.saaWOUT"
							  :picker-options="{
							    start: '16:00',
							    step: '00:10',
							    end: '19:30'
							  }"
							  placeholder="请选择老师下班时间">
							</el-time-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="22">
						<el-form-item :label="'开启收费记录'" prop="saaOPSF">
							<el-select v-model="ruleForm.saaOPSF" class="handle-select mr10">
								<el-option v-for="item in ruleForm.optionsOPSF" :key="item.OPSF" :label="item.OPSFDISP" :value="item.OPSF">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- <el-row>
					<el-col :span="22">
						<el-form-item :label="'开启视频放大'" prop="saaISFD">
							<el-select v-model="ruleForm.saaISFD" class="handle-select mr10">
								<el-option v-for="item in ruleForm.optionsISFD" :key="item.ISFD" :label="item.ISFDDISP" :value="item.ISFD">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row> -->
				<!-- 预付款设置 -->
				<!-- <el-row>
					<el-col :span="22">
						<el-form-item :label="'金额设置'" v-show="disVisible">
							<el-button type="primary" icon="el-icon-edit" @click="goYCJE(this.ruleForm.saaMSID)"></el-button>
						</el-form-item>
					</el-col>
				</el-row> -->
				<el-row>
					<el-col :span="24">
						<div class="submit">
							<el-form-item>
								<el-button @click="goBack()" class="goback">返回</el-button>
								<el-button :loading="submitFormLoading" type="primary" @click="submitForm('ruleForm')">提交</el-button>
							</el-form-item>
						</div>
					</el-col>
				</el-row>
			</el-form>
			<!-- vueCropper 剪裁图片实现-->
			<el-dialog :title="'剪裁图片'" :visible.sync="imgCutVisible" append-to-body>
				<div class="cropper-content">
					<div class="cropper" style="text-align:center">
						<vueCropper ref="cropper" :img="imgCutOption.img" :outputSize="imgCutOption.size" :outputType="imgCutOption.outputType"
						 :info="true" :full="imgCutOption.full" :canMove="imgCutOption.canMove" :canMoveBox="imgCutOption.canMoveBox"
						 :original="imgCutOption.original" :autoCrop="imgCutOption.autoCrop" :fixed="imgCutOption.fixed" :fixedNumber="imgCutOption.fixedNumber"
						 :centerBox="imgCutOption.centerBox" :infoTrue="imgCutOption.infoTrue" :fixedBox="imgCutOption.fixedBox"></vueCropper>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="imgCutVisible = false">返回</el-button>
					<el-button type="primary" @click="finish">提交</el-button>
				</div>
			</el-dialog>
			<!-- vueCropper 校园展示剪裁图片实现-->
			<el-dialog :title="'剪裁图片'" :visible.sync="imgCutVisible1" append-to-body>
				<div class="cropper-content">
					<div class="cropper" style="text-align:center">
						<vueCropper ref="cropper" :img="imgCutOption1.img" :outputSize="imgCutOption1.size" :outputType="imgCutOption1.outputType"
						 :info="true" :full="imgCutOption1.full" :canMove="imgCutOption1.canMove" :canMoveBox="imgCutOption1.canMoveBox"
						 :original="imgCutOption1.original" :autoCrop="imgCutOption1.autoCrop" :fixed="imgCutOption1.fixed" :fixedNumber="imgCutOption1.fixedNumber"
						 :centerBox="imgCutOption1.centerBox" :infoTrue="imgCutOption1.infoTrue" :fixedBox="imgCutOption1.fixedBox"></vueCropper>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="imgCutVisible1 = false">返回</el-button>
					<el-button type="primary" @click="finishSMG1">提交</el-button>
				</div>
			</el-dialog>
		</div>
		<!-- vueCropper 剪裁图片实现-->
		<el-dialog :title="'剪裁图片'" :visible.sync="imagCutVisible" append-to-body>
			<div class="cropper-content">
				<div class="cropper" style="text-align:center">
					<vueCropper ref="cropper" :img="imagCutOption.img" :outputSize="imagCutOption.size" :outputType="imagCutOption.outputType"
					 :info="true" :full="imagCutOption.full" :canMove="imagCutOption.canMove" :canMoveBox="imagCutOption.canMoveBox"
					 :original="imagCutOption.original" :autoCrop="imagCutOption.autoCrop" :fixed="imagCutOption.fixed" :fixedNumber="imagCutOption.fixedNumber"
					 :centerBox="imagCutOption.centerBox" :infoTrue="imagCutOption.infoTrue" :fixedBox="imagCutOption.fixedBox"></vueCropper>
				</div>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="imagCutVisible = false">返回</el-button>
				<el-button type="primary" @click="finishCut">提交</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'addGarden',
		data() {
			//验证字符串
			const validateFontSize = (rule, value, callback) => {
				if (value.toString().length == 0) {
					callback(new Error('请输入幼儿园名称')) //长度在1-20之间
				} else if (value.toString().length < 1 || value.toString().length > 20) {
					callback(new Error('请输入长度在1~20之间的字符')) //长度在1-20之间
				} else {
					this.checkSAANAME(value);
					if (this.isRepeat == true) {
						callback(new Error('幼儿园名称重复'));
					} else {
						callback();
					}
				}
			}
			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				submitFormLoading: false, // 提交按钮load效果
				disabledPABI: true,
				disabledPACI: true,
				disabledUAAI: false,
				imgCutVisible: false,
				imgCutVisible1: false,
				imagCutVisible: false,
				disVisible: true,
				imgCutOption: {
					img: '', // 裁剪图片的地址
					info: true, // 裁剪框的大小信息
					outputSize: 0.9, // 裁剪生成图片的质量
					outputType: 'jpg', // 裁剪生成图片的格式
					canScale: true, // 图片是否允许滚轮缩放
					autoCrop: true, // 是否默认生成截图框
					fixedBox: false, // 固定截图框大小 不允许改变
					fixed: true, // 是否开启截图框宽高固定比例
					fixedNumber: [1, 1], // 截图框的宽高比例
					full: false, // 是否输出原图比例的截图
					canMoveBox: true, // 截图框能否拖动
					original: false, // 上传图片按照原始比例渲染
					centerBox: false, // 截图框是否被限制在图片里面
					infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
				},
				imgCutOption1: { //院校展示（主图)
					img: '', // 裁剪图片的地址
					info: true, // 裁剪框的大小信息
					outputSize: 0.9, // 裁剪生成图片的质量
					outputType: 'jpg', // 裁剪生成图片的格式
					canScale: true, // 图片是否允许滚轮缩放
					autoCrop: true, // 是否默认生成截图框
					fixedBox: false, // 固定截图框大小 不允许改变
					fixed: true, // 是否开启截图框宽高固定比例
					fixedNumber: [1, 1], // 截图框的宽高比例
					full: false, // 是否输出原图比例的截图
					canMoveBox: true, // 截图框能否拖动
					original: false, // 上传图片按照原始比例渲染
					centerBox: false, // 截图框是否被限制在图片里面
					infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
				},
				imagCutOption: {
					img: '', // 裁剪图片的地址
					info: true, // 裁剪框的大小信息
					outputSize: 0.9, // 裁剪生成图片的质量
					outputType: 'jpg', // 裁剪生成图片的格式
					canScale: true, // 图片是否允许滚轮缩放
					autoCrop: true, // 是否默认生成截图框
					fixedBox: false, // 固定截图框大小 不允许改变
					fixed: true, // 是否开启截图框宽高固定比例
					fixedNumber: [1, 1], // 截图框的宽高比例
					full: false, // 是否输出原图比例的截图
					canMoveBox: true, // 截图框能否拖动
					original: false, // 上传图片按照原始比例渲染
					centerBox: false, // 截图框是否被限制在图片里面
					infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
				},
				
				isRepeat: false,
				ruleForm: {
					formDatabase64_HJ: [],
					editFiles_CD: [],
					imgbase64: '',
					saaNAME: '',
					saaSTAT: '1',
					saaZSJH: '',
					saaBMSJ: '',
					optionsPAAI: [],
					saaPAAI: '',
					optionsPABI: [],
					saaPABI: '',
					optionsPACI: [],
					saaUAAI: '',
					optionsUAAI: [],
					saaISFD: '0',
					saaOPSF: '0',
					optionsISFD: [
						{
							ISFD: '0',
							ISFDDISP: "不开启"
						},
						{
							ISFD: '1',
							ISFDDISP: "开启"
						}
					],
					optionsOPSF: [
						{
							OPSF: '0',
							OPSFDISP: "不开启"
						},
						{
							OPSF: '1',
							OPSFDISP: "开启"
						}
					],
					saaPACI: '',
					saaPTEL: '',
					saaNOTE: '',
					saaLOGO: '',
					// saaYCJE: '',
					saaADRS: '',
					saaSMG1: '',
					saaWINT: '', //老师上班时间
					saaWOUT: ''  //老师下班时间
				},
				rules: {
					saaWINT: [{
						required: true,
						message: '请选择上班时间', 
						trigger: ['blur', 'change'],
					}],
					saaWOUT: [{
						required: true,
						message: '请选择下班时间', 
						trigger: ['blur', 'change'],
					}],
					saaNAME: [{
						required: true,
						//message: '请输入幼儿园名称', //请输入社名称
						trigger: ['blur', 'change'],
						validator: validateFontSize
					}],
					saaPAAI: [{
						required: true,
						message: '请选择省',
						trigger: ['blur', 'change']
					}],

					saaPABI: [{
						required: true,
						message: '请选择市',
						trigger: ['blur', 'change']
					}],
					saaPACI: [{
						required: true,
						message: '请选择区',
						trigger: ['blur', 'change']
					}],
					saaISFD: [{
						required: true,
						message: '',
						trigger: ['blur', 'change']
					}],
					saaOPSF: [{
						required: true,
						message: '请选择是否开启收费记录',
						trigger: ['blur', 'change']
					}],
					saaUAAI: [{
						required: true,
						message: '请选择园长',
						trigger: ['blur', 'change']
					}],
					saaPTEL: [{
						required: true,
						message: '请输入电话',
						trigger: ['blur', 'change']
					}],
					saaADRS: [{
						required: true,
						message: '请输入详细地址',
						trigger: ['blur', 'change']
					}]
				}
			};
		},
		created() {
			//金设定权限设置
			if (this.web_role == '1') {
				this.disVisible = false;
			}
			var uid = this.$route.query.SAAMSID;
			this.getPAAI();
			this.getUAAI();

			// this.getSAA_IMG(uid);
			// this.getData(uid)
		},
		methods: {
			//验证幼儿园名称是否重复
			checkSAANAME(value) {
				const self_shop = this;
				
				var postUrl = 'WCF/WEB/svcSAA.svc/CHECK_SAA_NAME';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sSAAID: null, 
						sSAANM: value
					}
				)
				.then((response) => {
					//请求成功返回的数据
					if (response.data.KKSTR == "Y") {
						this.isRepeat = true;
					} else {
						this.isRepeat = false;
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
				});
			},
			getUAAI() {
				const self_agent = this;
				var postUrl = 'WCF/WEB/svcUAA.svc/Get_UAA_UAAI';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;

					if (resCount == 1) {
						this.ruleForm.optionsUAAI = response.data.KKDT;
						this.ruleForm.saaUAAI = response.data.KKDT[0].UAAMSID;
						this.disabledUAAI = true;
					} else if (resCount > 1) {
						this.ruleForm.optionsUAAI = response.data.KKDT;
						this.ruleForm.saaUAAI = '';
						this.disabledUAAI = false;

					} else {
						this.disabledUAAI = false;
						this.ruleForm.optionsUAAI = '';
						this.ruleForm.saaUAAI = '';
					}
				})
				.catch((error) => {
					this.ruleForm.saaUAAI = '';
					this.$message({
						message: '获取园长信息请求失败', //请求失败
						type: 'error'
					});
				});
			},
			getPAAI() {
				const self_agent = this;
				var postUrl = 'WCF/WEB/svcSAA.svc/Get_SAA_PAAI';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {
						this.ruleForm.optionsPAAI = response.data.KKDT;
					} else {
						this.ruleForm.optionsPAAI = '';
						this.ruleForm.saaPAAI = '';
					}
				})
				.catch((error) => {
					this.ruleForm.saaPAAI = '';
					this.$message({
						message: '获取幼儿园信息请求失败', //请求失败
						type: 'error'
					});
				});
			},
			//获取市信息
			getPABI(valuePAAI) {
				const self_agent = this;
				var postUrl = 'WCF/WEB/svcSAA.svc/GET_SAA_PABI';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
						sSAAI: valuePAAI //web侧 登录ID  tihs.web_suuid
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {
						this.ruleForm.optionsPABI = response.data.KKDT;
					} else {
						this.ruleForm.optionsPABI = '';
						this.ruleForm.saaPABI = '';
					}
				})
				.catch((error) => {
					this.ruleForm.saaPABI = '';
					this.$message({
						message: '获取市信息请求失败', //请求失败
						type: 'error'
					});
				});
			},
			getPACI(valuePAAI, valuePABI) {
				const self_agent = this;
				var postUrl = 'WCF/WEB/svcSAA.svc/Get_SAA_PACI';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
						sPAAI: valuePAAI,
						sPABI: valuePABI
					})
				.then((response) => {
					//请求成功返回的数据
					this.disabledPACI = false;
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {

						this.ruleForm.optionsPACI = response.data.KKDT;
					} else {
						this.ruleForm.optionsPACI = '';
						this.ruleForm.saaPACI = '';
					}
				})
				.catch((error) => {
					this.ruleForm.saaPACI = '';
					this.$message({
						message: '获取区信息请求失败', //请求失败
						type: 'error'
					});
				});
			},
			// 省选择事件
			paaiChange(valuePAAI) {

				this.disabledPACI = true;
				this.disabledPABI = true;
				this.ruleForm.saaPABI = '';
				this.ruleForm.saaPACI = '';

				if (typeof(valuePAAI) !== 'undefined') {
					this.getPABI(valuePAAI);
					this.disabledPABI = false;

				}
			},
			//上传头像
			uploadImg(file, fileList) {
				var that = this
				//判断图片类型
				if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/png' || file.raw.type == 'image/JPG') {
					var isJPG = true
				} else {
					isJPG = false
				}
				// 判断图片大小
				const isLt2M = file.raw.size / 1024 / 1024 < 20
				if (!isJPG) {
					that.$message.error('上传产品图片只能是 JPG/PNG/JPEG 格式!') //上传产品图片只能是 JPG/PNG/JPEG 格式!
					return false;
				}
				if (!isLt2M) {
					that.$message.error('上传产品图片大小不能超过 20MB!') //上传产品图片大小不能超过 20MB!
					return false;
				}

				if (isJPG && isLt2M) {
					var reader = new FileReader();
					reader.readAsDataURL(file.raw);
					reader.onload = function(e) {
						that.imgCutOption.img = this.result;
						that.imgCutVisible = true;
					}
				}
			},
			//上传院校展示(主图)
			uploadImgSMG1(file, fileList) {
				var that = this
				//判断图片类型
				if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/png' || file.raw.type == 'image/JPG') {
					var isJPG = true
				} else {
					isJPG = false
				}
				// 判断图片大小
				const isLt2M = file.raw.size / 1024 / 1024 < 20
				if (!isJPG) {
					that.$message.error('上传产品图片只能是 JPG/PNG/JPEG 格式!') //上传产品图片只能是 JPG/PNG/JPEG 格式!
					return false;
				}
				if (!isLt2M) {
					that.$message.error('上传产品图片大小不能超过 20MB!') //上传产品图片大小不能超过 20MB!
					return false;
				}

				if (isJPG && isLt2M) {
					var reader = new FileReader();
					reader.readAsDataURL(file.raw);
					reader.onload = function(e) {
						that.imgCutOption1.img = this.result;
						that.imgCutVisible1 = true;
					}
				}
			},
			// 剪切图片确定方法
			finish() {
				this.$refs.cropper.getCropBlob((data) => {
					var reader = new FileReader();
					reader.readAsDataURL(data);
					var that = this;
					reader.onload = function(e) {
						that.ruleForm.saaLOGO = this.result;
						that.ruleForm.imgbase64 = this.result;
						that.imgCutVisible = false;
					}
				})
			},
			finishSMG1() {
				this.$refs.cropper.getCropBlob((data) => {
					var reader = new FileReader();
					reader.readAsDataURL(data);
					var that = this;
					reader.onload = function(e) {
						that.ruleForm.saaSMG1 = this.result;
						that.imgCutVisible1 = false;
					}
				})
			},
			handleExceed_HJ(file, fileList) {
				this.$message.error('最多可上传4张图片');
			},
			handleRemove_HJ(file, fileList) {
				this.ruleForm.editFiles_CD.forEach((team, index) => {
					if (team.name === file.name) {
						this.ruleForm.editFiles_CD.splice(index, 1)
					}
				});
				this.ruleForm.formDatabase64_HJ.forEach((team, index) => {
					if (team.name === file.name) {
						this.ruleForm.formDatabase64_HJ.splice(index, 1)
					}
				});
			},
			//上传菜单图片
			uploadMABImg_HJ(file, fileList) {
				var that = this
				//判断图片类型
				if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/png' || file.raw.type == 'image/JPG') {
					var isJPG_HJ = true
				} else {
					isJPG_HJ = false
				}
				// 判断图片大小
				const isLt40kb_HJ = file.raw.size / 1024 / 1024 < 20
				if (!isJPG_HJ) {
					that.$message.error('上传产品图片只能是 JPG/PNG/JPEG 格式!') //上传环境图片只能是 JPG/PNG/JPEG 格式!
					that.$refs.imgdaa.uploadFiles.pop();
					return;
				}
				if (!isLt40kb_HJ) {
					that.$message.error('上传产品图片大小不能超过 20MB!') //上传环境图片大小不能超过 20MB!
					that.$refs.imgdaa.uploadFiles.pop();
					return;
				}

				if (isJPG_HJ && isLt40kb_HJ) {
					var reader = new FileReader();
					reader.readAsDataURL(file.raw);
					reader.onload = function(e) {
						that.imagCutOption.img = this.result;
						that.imagCutVisible = true;
					}
				}
				that.$refs.imgdaa.uploadFiles.pop();
			},
			finishCut() {
				this.$refs.cropper.getCropBlob((data) => {
					var reader = new FileReader();
					reader.readAsDataURL(data);
					var that = this;
					reader.onload = function(e) {
						var obj = new Object();
						obj.url = this.result;
						var temp = new Date().getTime();
						obj.name = temp;
						that.ruleForm.editFiles_CD.push(obj);

						var obje = new Object();
						obje.name = temp;
						obje.url = this.result;
						that.ruleForm.formDatabase64_HJ.push(obje);
						that.imagCutVisible = false;
					}
				})
			},
			//幼儿园新增
			submitForm(formName) {
				this.submitFormLoading = true;
				let rulArr = [];
				debugger;
				this.ruleForm.formDatabase64_HJ.forEach((team, index) => {
					rulArr.push(team.url);
					//console.log(team.url);
				});
				this.$refs[formName].validate((valid) => {
					if (valid) {
						const self = this;
						var postUrl = 'WCF/WEB/svcSAA.svc/ADD_SAA';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
									sSAASTAT: self.ruleForm.saaSTAT,
									sSAAPAAI: self.ruleForm.saaPAAI ? self.ruleForm.saaPAAI : '',
									sSAAPABI: self.ruleForm.saaPABI ? self.ruleForm.saaPABI : '',
									sSAAPACI: self.ruleForm.saaPACI ? self.ruleForm.saaPACI : '',
									sSAANAME: self.ruleForm.saaNAME,
									sSAAADRS: self.ruleForm.saaADRS,
									sSAAPTEL: self.ruleForm.saaPTEL,
									sSAAUAAI: self.ruleForm.saaUAAI ? self.ruleForm.saaUAAI : '',
									sSAANOTE: self.ruleForm.saaNOTE,
									sSAALOGO: self.ruleForm.imgbase64,
									sSMGIMAG1: self.ruleForm.saaSMG1, //院校展示主图，只有一个									
									sSAAIMAG: rulArr,
									sSAAZSJH: self.ruleForm.saaZSJH,
									sSAABMSJ: self.ruleForm.saaBMSJ,
									// sSAAYCJE: self.ruleForm.saaYCJE
									sSAAWINT: self.ruleForm.saaWINT,
									sSAAWOUT: self.ruleForm.saaWOUT,
									sSAAISFD: self.ruleForm.saaISFD,
									sSAAOPSF: self.ruleForm.saaOPSF
								}
							)
							.then((response) => {
								//请求成功返回的数据
								this.submitFormLoading = false;
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;

								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '添加幼儿园失败', //新增失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('添加幼儿园成功'); // 新增成功
										this.$router.push('/gardenList') // 跳转路由
										this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件 reload

										var indexs;
										for (let i = 0; i < this.COMM.tagsLists.length; i++) {
											if (this.COMM.tagsLists[i].name == "addGarden") {
												indexs = i;
												break;
											}
										}

										this.closeTags(indexs);
									}
								} else {
									this.$message({
										message: '添加幼儿园请求失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								this.$message({
									message: '添加幼儿园请求失败', //请求失败
									type: 'error'
								});
							});
					} else {
						this.$message({
							message: 表单验证失败, //表单验证失败
							type: 'error'
						});
						this.submitFormLoading = false;
					}
				});
			},
			// 金额设置
			// goYCJE(SAAMSID) {
			// 	// 跳转路由
			// 	this.$router.push({
			// 		name: 'editSAAYCJE',
			// 		query: {
			// 			SAAMSID: SAAMSID
			// 		}
			// 	})
			// 	//this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件 reload
			// },
			// 关闭单个标签
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			//返回
			goBack() {
				this.$router.go(-1);

				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "addGarden") {
						indexs = i;
						break;
					}
				}

				this.closeTags(indexs);
			}
		}
	}
</script>

<style scoped>
	.font {
		font-size: 14px;
	}

	.el-upload--text {
		background-color: #fff;
		border: 1px solid #d9d9d9;
		border-radius: 128px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 128px;
		height: 128px;
		text-align: center;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	}

	.el-dialog__footer {
		text-align: center;
		height: 80px;
	}

	.el-upload-list--picture-card .el-upload-list__item-status-label {
		top: -65px;
	}

	.el-dialog__footer button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.avatar-uploader .el-upload {
		width: 200px;
		height: 120px;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 200px;
		height: 120px;
		line-height: 120px;
		text-align: center;
	}

	.avatar {
		width: 200px;
		height: 120px;
		display: block;
	}

	.picture-card_RZ .el-upload--picture-card {
		width: 226px;
		height: 160px;
		line-height: 160px;
	}

	.picture-card_RZ .el-upload--picture-card .el-upload-list__item .is-ready .el-upload-list__item-thumbnail {
		width: 226px;
		height: 160px;
		line-height: 160px;
	}

	.picture-card_RZ .el-upload-list--picture-card .el-upload-list__item {
		width: 226px;
		height: 160px;
		line-height: 160px;
	}

	.el-input {
		width: 100%;
	}

	.el-input-number__decrease,
	.el-input-number__increase {
		position: absolute;
		z-index: 1;
		top: 1px;
		width: 40px;
		height: 34px;
		text-align: center;
		background: #F5F7FA;
		color: #606266;
		cursor: pointer;
		font-size: 13px;
	}

	.handle-input {
		width: 85%;
	}

	.select-shop .el-input {
		width: 300px;
	}

	.submit {
		margin-left: 35%;
	}

	.submit button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.goback {
		margin-right: 15px;
	}

	.el-row {
		margin-top: 16px;
	}

	.el-input--small .el-input__inner {
		font-size: 14px;
		padding-left: 10px;
	}


	.cropper {
		width: auto;
		height: 300px;
	}
</style>
